
/**
 * Completion Record Status Enum
 */
export const CompletionRecordStatus = Object.freeze({
  COMPELTE: "Complete", 
  INCOMPLETE: "Incomplete",
  PENDING: "Not Started",
  FORCE_COMPLETE: "Force Complete"
});
